import { gql } from "gql";

export const READ_ALL_NOTIFICATIONS = gql(/* GraphQL */ `
  mutation ReadAllNotifications {
    readAllNotifications
  }
`);
